﻿export enum NavDataType {
    airport = 0,
    airspace = 1,
    airway = 2,
    fixes = 3,
    flightServiceStation = 4,
    holding = 5,
    gridMora = 6,
    navaids = 7,
    sids = 8,
    stars = 9,
    sua = 10,
    timeZone = 11,
    weatherStation = 12
}
